<template>
  <div
    class="breadcrumb-area bg-img"
    :style="{
      'background-image':
        'url(' + $backendPublic + getSettings.baner.value + ')',
    }"
  >
    <div class="container">
      <div class="row">
        <div class="col">
          <div class="page-banner text-center">
            <h1>{{ title }}</h1>
            <b-breadcrumb class="page-breadcrumb" :items="items"></b-breadcrumb>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { settingStore } from "@/store/Modules/setting.js"
import { mapState } from "pinia"
import { mapStores } from "pinia"
import { mapActions } from "pinia"
export default {
  props: ["items", "title"],
  computed: {
    ...mapState(settingStore, ["getSettings"]),
  },
}
</script>
